import React from "react";
import carImage from "../../../assets/img/sitemap/carimage.svg";
import "./siteMap.css"; // Import custom styles

export default function SiteMapSection() {
  return (
    <div className="container">
      <h4 className="custom-heading">Sitemap</h4>
      <div className="row">
        <div className="col-md-3 mb-4">
          <h6 className="fw-bold" style={{ fontSize: "15px" }}>
            Home
          </h6>
          <ul className="list-unstyled text-muted">
            <li
              style={{ fontWeight: "400", fontSize: "13px", color: "#6c757d" }}
            >
              UAIC Home
            </li>
            <li
              style={{ fontWeight: "400", fontSize: "13px", color: "#6c757d" }}
            >
              About Us
            </li>
            <li
              style={{ fontWeight: "400", fontSize: "13px", color: "#6c757d" }}
            >
              Insurance
            </li>
            <li
              style={{ fontWeight: "400", fontSize: "13px", color: "#6c757d" }}
            >
              Site Map
            </li>
            <li
              style={{ fontWeight: "400", fontSize: "13px", color: "#6c757d" }}
            >
              Site Requirements
            </li>
            <li
              style={{ fontWeight: "400", fontSize: "13px", color: "#6c757d" }}
            >
              Privacy Policy
            </li>
          </ul>
        </div>

        <div className="col-md-3 mb-4">
          <h6 className="fw-bold">Agent Login</h6>
          <ul className="list-unstyled text-muted">
            <li
              style={{ fontWeight: "400", fontSize: "13px", color: "#6c757d" }}
            >
              Florida
            </li>
            <li
              style={{ fontWeight: "400", fontSize: "13px", color: "#6c757d" }}
            >
              Georgia
            </li>
            <li
              style={{ fontWeight: "400", fontSize: "13px", color: "#6c757d" }}
            >
              Texas
            </li>
          </ul>
        </div>

        <div className="col-md-3 mb-4">
          <h6 className="fw-bold">Community</h6>
          <div className="d-flex">
            <ul className="list-unstyled text-muted me-5">
              <li
                style={{
                  fontWeight: "400",
                  fontSize: "13px",
                  color: "#6c757d",
                }}
              >
                Careers
              </li>
              <li
                style={{
                  fontWeight: "400",
                  fontSize: "13px",
                  color: "#6c757d",
                }}
              >
                Apply Online
              </li>
              <li
                style={{
                  fontWeight: "400",
                  fontSize: "13px",
                  color: "#6c757d",
                }}
              >
                Benefits
              </li>
              <li
                style={{
                  fontWeight: "400",
                  fontSize: "13px",
                  color: "#6c757d",
                }}
              >
                Diversity
              </li>
              <li
                style={{
                  fontWeight: "400",
                  fontSize: "13px",
                  color: "#6c757d",
                }}
              >
                Claims
              </li>
              <li
                style={{
                  fontWeight: "400",
                  fontSize: "13px",
                  color: "#6c757d",
                }}
              >
                FAQ
              </li>
            </ul>
            <ul className="list-unstyled text-muted">
              <li
                style={{
                  fontWeight: "400",
                  fontSize: "13px",
                  color: "#6c757d",
                }}
              >
                Job Fairs
              </li>
              <li
                style={{
                  fontWeight: "400",
                  fontSize: "13px",
                  color: "#6c757d",
                }}
              >
                Accounting
              </li>
              <li
                style={{
                  fontWeight: "400",
                  fontSize: "13px",
                  color: "#6c757d",
                }}
              >
                Underwriting
              </li>
              <li
                style={{
                  fontWeight: "400",
                  fontSize: "13px",
                  color: "#6c757d",
                }}
              >
                Corporate & Executive
              </li>
              <li
                style={{
                  fontWeight: "400",
                  fontSize: "13px",
                  color: "#6c757d",
                }}
              >
                Information & Technology
              </li>
            </ul>
          </div>
        </div>

        <div className="col-md-3 mb-4">
          <h6 className="fw-bold">Contact Us</h6>
          <ul className="list-unstyled text-muted">
            <li
              style={{ fontWeight: "400", fontSize: "13px", color: "#6c757d" }}
            >
              Florida
            </li>
            <li
              style={{ fontWeight: "400", fontSize: "13px", color: "#6c757d" }}
            >
              Georgia
            </li>
          </ul>
        </div>
      </div>

      <div>
        <img
          src={carImage}
          alt="car"
          style={{
            bottom: 0,
            right: 0,
            width: "100%",
          }}
        />
      </div>
    </div>
  );
}
